import FormBody from "../../../../components/form-body";

export default function ContactUsFormSkeleton() {
  return (
    <div className="animate-pulse">
      <FormBody>
        <div className="mb-4">
          <div className="h-5 w-24 bg-gray-200 rounded mb-2"></div>
          <div className="h-10 w-full bg-gray-200 rounded"></div>
        </div>
        <div className="mb-4">
          <div className="h-5 w-24 bg-gray-200 rounded mb-2"></div>
          <div className="h-10 w-full bg-gray-200 rounded"></div>
        </div>
        <div className="mb-4">
          <div className="h-5 w-24 bg-gray-200 rounded mb-2"></div>
          <div className="h-10 w-full bg-gray-200 rounded"></div>
        </div>
        <div className="mb-4">
          <div className="h-5 w-24 bg-gray-200 rounded mb-2"></div>
          <div className="h-24 w-full bg-gray-200 rounded"></div>
        </div>
        <div className="mb-4">
          <div className="h-5 w-24 bg-gray-200 rounded mb-2"></div>
          <div className="h-6 w-12 bg-gray-200 rounded"></div>
        </div>
      </FormBody>
      <div className="mt-6 flex justify-end gap-4">
        <div className="h-10 w-24 bg-gray-200 rounded"></div>
        <div className="h-10 w-32 bg-gray-200 rounded"></div>
      </div>
    </div>
  );
}
